"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bnCode = void 0;
const bnCode = (code) => {
    const codeLength = code.length;
    if (codeLength >= 5 && code.slice(0, 2) == "BN") {
        return code.slice(2);
    }
    else {
        return code;
    }
};
exports.bnCode = bnCode;
